onComplete(function () {

	const isHome = document.querySelector("html[data-home='true']");
	const header = document.querySelector('header.nav-header');
	const navLinks = document.querySelectorAll('header.nav-header .nav-link');
	const navToggler = document.querySelectorAll('.nav-header .navbar-toggler-icon i');
	const topNavItem = document.querySelector('.nav-header .navbar-top .btn-link');

	let prevScrollPos;
	let currentScrollPos = document.documentElement.scrollTop;

	window.addEventListener('scroll', function () {

		currentScrollPos = document.documentElement.scrollTop;
		if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
			header.style.translate = "0 0";
		} else {
			header.style.translate = "0 -100%";
		}
		prevScrollPos = currentScrollPos;

		if (isHome) {
			currentScrollPos = document.documentElement.scrollTop;
			if (currentScrollPos > 50) {
				header.style.backgroundColor = "var(--white)";
				header.style.boxShadow = "var(--box-shadow-2)";
				topNavItem.style.color = "var(--background)";
				navLinks.forEach(link => {
					link.style.color = "var(--background)";
				});
				navToggler.forEach(toggler => {
					toggler.style.backgroundColor = "var(--background)";
				});
			} else {
				header.style.backgroundColor = "transparent";
				header.style.boxShadow = "unset";
				topNavItem.style.color = "var(--white)";
				navLinks.forEach(link => {
					link.style.color = "var(--white)";
				});
				navToggler.forEach(toggler => {
					toggler.style.backgroundColor = "var(--white)";
				});
			}
		}

	});

	const buttons = document.querySelectorAll('.btn-secondary');

	buttons.forEach(button => {
		const originalContent = button.innerHTML;
		button.innerHTML = `<span>${originalContent}</span>`;
	});


	const divLink = document.querySelectorAll('.lunch-slider .lunch-item');

	if (divLink) {
		divLink.forEach(link => {
			link.classList.add('stretch-link');
		});
	}

});
